import React from 'react'

const PrintModalStart = () => {
  return (
    <>
          <div className="modal fade" id="printModal" tabindex="-1" role="dialog" aria-labelledby="printModalLabel">
                <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="custom-control custom-checkbox custom-checkbox-blue mt-3">
                                        <input type="checkbox" className="custom-control-input custom-control-input-blue" id="customCheck1" />
                                        <label className="custom-control-label pt-1" for="customCheck1">Quotation</label>
                                    </div>
                                    <div className="custom-control custom-checkbox custom-checkbox-blue mt-3">
                                        <input type="checkbox" className="custom-control-input custom-control-input-blue" id="customCheck2" />
                                        <label className="custom-control-label pt-1" for="customCheck2">Submittal Data</label>
                                    </div>
                                    <div className="custom-control custom-checkbox custom-checkbox-blue mt-3">
                                        <input type="checkbox" className="custom-control-input custom-control-input-blue" id="customCheck3" />
                                        <label className="custom-control-label pt-1" for="customCheck3">Installation Instructions</label>
                                    </div>
                                    <div className="custom-control custom-checkbox custom-checkbox-blue mt-3">
                                        <input type="checkbox" className="custom-control-input custom-control-input-blue" id="customCheck4" />
                                        <label className="custom-control-label pt-1" for="customCheck4">Equipment Schedule</label>
                                    </div>
                                    <div className="custom-control custom-checkbox custom-checkbox-blue mt-3">
                                        <input type="checkbox" className="custom-control-input custom-control-input-blue" id="customCheck5" />
                                        <label className="custom-control-label pt-1" for="customCheck5">Option 5</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-5">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="preview-btns">
                                        <button type="button" className="btn cancel-btn mr-1" data-dismiss="modal">Cancel</button>
                                        <button type="button" className="btn preview-btn" data-dismiss="modal">Preview</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </>
  )
}

export default PrintModalStart